import {isNil} from 'ramda';
import {isNotNilOrEmpty} from 'ramda-adjunct';

import {
  GetMetadaServiceCaseApiResponse,
  GetPendingServiceItemsApiResponse,
  GetPendingServiceOrderReturnApiResponse,
} from '@dms/api/workshop';
import {queryParams, logError} from '@dms/shared';

import {useQueryState} from 'shared/web';

interface UseServiceCaseDetailHandlersProps {
  pendingServiceItems?: GetPendingServiceItemsApiResponse;
  pendingServiceOrderReturn?: GetPendingServiceOrderReturnApiResponse;
  serviceCase?: GetMetadaServiceCaseApiResponse;
}

export function useServiceCaseDetailHandlers(props: UseServiceCaseDetailHandlersProps) {
  const [, setOrderId] = useQueryState(queryParams.SERVICE_CASE_ORDER_ID);
  const [, setAddLabourJobId] = useQueryState(queryParams.SERVICE_CASE_ADD_LABOUR_JOB_ID);
  const [, setAddMaterialRequestJobId] = useQueryState(
    queryParams.SERVICE_CASE_ADD_MATERIAL_REQUEST_JOB_ID
  );
  const [, setServiceOrderReturnId] = useQueryState(queryParams.SERVICE_ORDER_RETURN_ID);
  const [, setServiceOrderReturnAuthorizationProfileId] = useQueryState(
    queryParams.SERVICE_ORDER_RETURN_AUTHORIZATION_PROFILE_ID
  );

  const handlePendingLabourClick = () => {
    const labourBasket = props.pendingServiceItems?.workBasket;
    if (!isNotNilOrEmpty(labourBasket)) {
      return;
    }

    setAddLabourJobId(labourBasket?.[0]?.serviceJobId ?? '');
    setOrderId(labourBasket?.[0]?.serviceOrderId ?? '');
  };

  const handlePendingMaterialClick = () => {
    const materialBasket = props.pendingServiceItems?.materialBasket;
    if (!isNotNilOrEmpty(materialBasket)) {
      return;
    }

    setAddMaterialRequestJobId(materialBasket?.[0]?.serviceJobId ?? '');
    setOrderId(materialBasket?.[0]?.serviceOrderId ?? '');
  };

  const handlePendingReturnClick = () => {
    const returnId = props.pendingServiceOrderReturn?.serviceOrderReturnId;
    const authProfileId = props.serviceCase?.authorizationProfileId;

    if (isNil(returnId)) {
      return logError('serviceOrderReturnId is not defined');
    }
    if (isNil(authProfileId)) {
      return logError('authorizationProfileId is not defined');
    }

    setServiceOrderReturnId(returnId);
    setServiceOrderReturnAuthorizationProfileId(authProfileId);
  };

  return {handlePendingLabourClick, handlePendingMaterialClick, handlePendingReturnClick};
}
